import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeProvider';

interface ThemeToggleProps {
  className?: string;
}

/** Light/dark theme switch — flips Sprout token mode and persists. */
export default function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { mode, toggle } = useTheme();
  const isDark = mode === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      className={`inline-flex items-center justify-center rounded-md p-2 text-textSecondary hover:text-textPrimary hover:bg-surfaceHover transition-colors ${className}`}
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
